import React from "react"
import SectionHeader from "../../molecules/SectionHeader/index"
import SectionImage from "../../molecules/SectionImage"
import handleCalendly from "../../../functions/handleCalendly"
import CTA from "../../atoms/CTA/index"
import "./styles.scss"
const ContactUs = ({
  title,
  subtitle,
  contactUsLink,
  callUsLink,
  contactUsTitle,
  callUsTitle,
}) => {
  return (
    <section className="section section--contactUs">
      <div className="wrapper--text">
        <SectionHeader
          animate
          type="h2"
          attributes={{
            "data-sal": "slide-up",
            "data-sal-duration": "1000",
            "data-sal-easing": "ease",
          }}
          subtitle="EXCITED?"
        >
          Let's build or improve your digital product
        </SectionHeader>
        <div className="contactUs__buttons">
          <CTA to={`/contact/`} className="btn--dark btn--filled btn--contact">
            {contactUsTitle}
          </CTA>
          <a
            className="btn btn--light btn--filled btn--schedule"
            onClick={e => {
              e.preventDefault()
              handleCalendly()
            }}
          >
            {callUsTitle}
          </a>
        </div>
      </div>
    </section>
  )
}

ContactUs.defaultProps = {
  title: `Let’s build your next digital product`,
  subtitle: `ARE YOU READY?`,
  contactUsLink: `contact/`,
  contactUsTitle: `Contact Us`,
  callUsLink: `#`,
  callUsTitle: `Schedule a Call`,
}

export default ContactUs
